import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import axios from "axios";

const OSMMap = ({ lat, lng }) => {
  const svgRef = useRef(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchOSMData = async () => {
      try {
        const delta = 0.005; // 100 meters in latitude/longitude degrees
        const lat1 = lat - delta;
        const lon1 = lng - delta;
        const lat2 = lat + delta;
        const lon2 = lng + delta;

        const query = `
        [out:json];
        (
          way["highway"]["lanes"](${lat1},${lon1},${lat2},${lon2});
          node["highway"="traffic_signals"](${lat1},${lon1},${lat2},${lon2});
        );
        out body;
        >;
        out skel qt;
        `;

        const response = await axios.post(
          "https://overpass-api.de/api/interpreter",
          query,
          { headers: { "Content-Type": "text/plain" } }
        );

        setData(response.data.elements);
      } catch (error) {
        console.error("Error fetching OSM data:", error);
      }
    };

    fetchOSMData();
  }, [lat, lng]);

  useEffect(() => {
    if (!data) return;

    // Clear previous SVG content
    d3.select(svgRef.current).selectAll("*").remove();

    // Create an SVG container
    const svg = d3.select(svgRef.current)
      .attr("width", 800)
      .attr("height", 600);

    const projection = d3.geoMercator()
      .center([lng, lat])
      .scale(1000000000) // Adjust scale for detailed rendering
      .translate([400, 300]); // Center SVG

    const lineGenerator = d3.line()
      .x((d) => projection([d.lon, d.lat])[0])
      .y((d) => projection([d.lon, d.lat])[1]);

    // Draw lanes (ways)
    data
      .filter((el) => el.type === "way" && el.nodes)
      .forEach((way) => {
        svg.append("path")
          .datum(way.nodes.map((nodeId) => {
            const node = data.find((el) => el.type === "node" && el.id === nodeId);
            return node ? { lat: node.lat, lon: node.lon } : null;
          }).filter(Boolean)) // Filter out invalid nodes
          .attr("d", lineGenerator)
          .attr("fill", "none")
          .attr("stroke", "#0077FF")
          .attr("stroke-width", 2);
      });

    // Draw traffic signals
    data
      .filter((el) => el.type === "node" && el.tags && el.tags.highway === "traffic_signals")
      .forEach((signal) => {
        const [x, y] = projection([signal.lon, signal.lat]);

        svg.append("circle")
          .attr("cx", x)
          .attr("cy", y)
          .attr("r", 5)
          .attr("fill", "red")
          .attr("stroke", "black");
      });
  }, [data, lat, lng]);

  return (
    <div>
      <h2>OSM Map Visualization</h2>
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default OSMMap;
